var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextjs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_5191)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.9995,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.4995,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.147 111.936H122.008V113.428H104.876V124.657H120.987V126.149H104.876V138.476H122.205V139.968H103.147V111.936ZM123.698 111.936H125.702L134.582 124.264L143.659 111.936L156.005 96.2773L135.722 125.56L146.174 139.968H144.091L134.582 126.855L125.034 139.968H122.991L133.521 125.56L123.698 111.936ZM146.92 113.428V111.936H168.414V113.428H158.512V139.968H156.783V113.428H146.92Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5518 111.937H81.7129L111.514 156.317L99.1985 139.968L81.3593 114.057L81.2807 139.968H79.5518V111.937Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.24 138.026C168.597 138.026 168.858 137.754 168.858 137.402C168.858 137.05 168.597 136.778 168.24 136.778C167.887 136.778 167.622 137.05 167.622 137.402C167.622 137.754 167.887 138.026 168.24 138.026ZM169.939 136.384C169.939 137.423 170.692 138.102 171.789 138.102C172.958 138.102 173.665 137.402 173.665 136.187V131.908H172.723V136.183C172.723 136.857 172.382 137.218 171.781 137.218C171.242 137.218 170.877 136.882 170.864 136.384H169.939ZM174.897 136.329C174.964 137.41 175.868 138.102 177.214 138.102C178.652 138.102 179.552 137.377 179.552 136.22C179.552 135.311 179.039 134.808 177.794 134.519L177.125 134.356C176.335 134.171 176.015 133.924 176.015 133.492C176.015 132.948 176.511 132.591 177.256 132.591C177.962 132.591 178.45 132.939 178.538 133.497H179.455C179.4 132.478 178.5 131.762 177.268 131.762C175.944 131.762 175.061 132.478 175.061 133.555C175.061 134.444 175.561 134.972 176.659 135.227L177.441 135.416C178.244 135.604 178.597 135.881 178.597 136.342C178.597 136.878 178.042 137.268 177.285 137.268C176.474 137.268 175.91 136.903 175.83 136.329H174.897Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_5191",
    x: -0.000488281,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_5191"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_5191",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjs);
export default __webpack_public_path__ + "static/media/nextjs.918fc8b8d0eb9fe6fdb1cc33edccd86a.svg";
export { ForwardRef as ReactComponent };